import config from 'config';

export const buildLinkServiceDonateUrl = (pageId: string) =>
  `${
    config.LINK_SERVICE_BASE_URI
  }/v1/crowdfundingpage/donate/pageid/${pageId}?startedBy=cfwebsite`;
